import React, {useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {
  fetchStoreInformation,
  storeInformation,
  error,
} from '../../redux/storeInformationSlice';
import {LANDING_PATH} from '../../routes/route-constants';
import {useAppDispatch, useAppSelector} from '../../redux/hooks';
import {setEnableMobileInput} from '../../redux/globalSlice';
import {
  getStoreCode,
  getStoreLatitude,
  getStoreLongitude,
  setStoreInformation,
  setStoreLatitude,
  setStoreLongitude,
  getUserType,
} from '../../core/localstorage-data';

import useGeoLocation from '../../components/common/useGeoLocation';
import cogoToast from 'cogo-toast';
import ErrorToast from '../../components/notifications/ErrorToast';
import {qrCodeEvent} from '../../lib/constants';
import {storeDetailInfo} from '../../lib/types';
import {storeCodeGtmData} from '../../lib/tagmanager';
export const Otptext = () => {
  const navigate = useHistory();
  const UserType = getUserType();
  const dispatch = useAppDispatch();
  const storeInformationData = useAppSelector(storeInformation);

  const storeInformationError = useAppSelector(error);
  const storeCode = getStoreCode();
  const [storeName, setStoreName] = useState('');

  //const location = useGeoLocation();
  console.log(storeCode);
  useEffect(() => {
    if (Object.keys(storeInformationData).length === 0) {
      dispatch(setEnableMobileInput(true));
      cogoToast.error(
        <ErrorToast
          title="Error"
          description="Currently we are not able to fetch store information. Please try again."
        />,
        {
          hideAfter: 3,
          renderIcon: () => {
            return null;
          },
        },
      );
      setTimeout(() => {
        window.location.href = '/qrcode';
      }, 3000);
    }

    if (storeInformationData != null && storeInformationData.result === true) {
      // if (storeCode != null) {
      //   // const storeDetail: storeDetailInfo = {
      //   //   storecode: storeCode,
      //   //   storeaddress: storeInformationData.store_name,
      //   //   storecitypincode: storeInformationData.pincode,
      //   //   store_name: storeInformationData.store_name,
      //   //   entity: storeInformationData.entity,

      //   //   event: qrCodeEvent,
      //   // };
      //   // storeCodeGtmData(storeDetail);
      // }
      setStoreName(storeInformationData.store_name);
      setStoreInformation(storeInformationData);
    }
    if (storeInformationError) {
      dispatch(setEnableMobileInput(true));
      cogoToast.error(
        <ErrorToast
          title="Error"
          description="Currently we are not able to fetch store information. Please try again."
        />,
        {
          hideAfter: 3,
          renderIcon: () => {
            return null;
          },
        },
      );
      setTimeout(() => {
        window.location.href = '/qrcode';
      }, 3000);
    }
  }, [storeInformationData, storeInformationError]);

  if (UserType === null) {
    navigate.replace(LANDING_PATH);
  }

  useEffect(() => {
    if (UserType === 'employee') {
      if (storeInformationData.message === '') {
        localStorage.clear();
        window.location.href = 'employeesignin';
      }
    } else {
      const payload = {
        mobile_number: '',
        store_input_code: storeCode,
      };
      dispatch(fetchStoreInformation(payload));
    }
  }, []);
  const scanQrHandler = () => {
    navigate.push(LANDING_PATH);
  };

  // const userLong = location.coordinates.lat;
  // const userLat = location.coordinates.lng;

  // function distancePoints(
  //   userLat: any,
  //   userLong: any,
  //   storeLat: any,
  //   storeLong: any,
  // ) {
  //   // distance between latitudes
  //   // and longitudes
  //   const dLat = ((storeLat - userLat) * Math.PI) / 180.0;
  //   const dLon = ((storeLong - userLong) * Math.PI) / 180.0;

  //   // convert to radiansa
  //   userLat = (userLat * Math.PI) / 180.0;
  //   storeLat = (storeLat * Math.PI) / 180.0;

  //   // apply formulae
  //   const a =
  //     Math.pow(Math.sin(dLat / 2), 2) +
  //     Math.pow(Math.sin(dLon / 2), 2) * Math.cos(userLat) * Math.cos(storeLat);
  //   const rad = 6371;
  //   const c = 2 * Math.asin(Math.sqrt(a));
  //   return rad * c;
  // }

  // useEffect(() => {
  //   const storeLat = storeInformationData.latitude;
  //   setStoreLatitude(storeLat);
  //   const storeLong = storeInformationData.longitude;
  //   setStoreLongitude(storeLong);
  // const userLat = location.coordinates.lat;
  // const userLong = location.coordinates.lng;

  // const storeLat = 28.725455699999998;
  // const storeLong = 77.2060128;
  // const userLat = 28.717073;
  // const userLong = 77.206002;

  //   const distance = distancePoints(
  //     userLat,
  //     userLong,
  //     getStoreLatitude(),
  //     getStoreLongitude(),
  //   );
  //   //const distanceMeters = distance*1000;
  //   const distanceMeters = 1000;
  //   //console.log(d);
  //   if (distanceMeters > 500) {
  //     //  navigate.replace(LANDING_PATH );
  //     //   console.log(" user is not near store");
  //     //   cogoToast.error(
  //     //     <ErrorToast title="Error" description="Please stay near store" />,
  //     //     {
  //     //       hideAfter: 3,
  //     //       renderIcon: () => {
  //     //         return null;
  //     //       },
  //     //     },
  //     //   );
  //   }
  // }, [storeInformationData]);

  return (
    <div className="grid place-items-center overflow-y-auto">
      <div>
        <p className="font-roboto text-big text-center">
          Get <b>started</b>
        </p>
      </div>
      <div className="text-center">
        {UserType === 'customer' ? (
          <div>
            <p className="pl-4 pr-1 text-xl font-medium mt-3 font-roboto">
              <span>Welcome to Max Store at </span>
              {storeName}
            </p>
            <p className="text-sm mt-2 text-black_zero text-opacity-50 font-roboto">
              Incase you are in a different store, scan the nearest QR code
              &nbsp;
              <a onClick={scanQrHandler}>
                <b className="text-red-600 ">Scan QR</b>
              </a>
            </p>
          </div>
        ) : (
          <div>
            {UserType === 'employee' ? (
              <div>
                <p className="text-sm mt-2 text-black_zero text-opacity-50 font-roboto">
                  <span>Enter customer’s phone number to begin </span>
                </p>
              </div>
            ) : (
              ''
            )}
          </div>
        )}
      </div>
    </div>
  );
};
